module.exports = __webpack_public_path__ + "media/images/front/icons/close-41a7d669421429a8360e95d283cb603d.svg";